module.exports = __webpack_public_path__ + "static/img/5en.642b98c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/realme/5en.png
// module id = rrwy
// module chunks = 0